var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFullscreen = function SvgIconFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M12.19 5.672H5.672v6.518H3.5V4.586c0-.6.486-1.086 1.086-1.086h7.604zM15.81 5.672h6.518v6.518H24.5V4.586c0-.6-.486-1.086-1.086-1.086H15.81zM5.672 22.328h6.518V24.5H4.586c-.6 0-1.086-.486-1.086-1.086V15.81h2.172zM23.414 24.5H15.81v-2.172h6.518V15.81H24.5v7.604c0 .6-.486 1.086-1.086 1.086"
  })));
};
export default SvgIconFullscreen;